import { useContext } from 'react';
import ThemeContext, { ThemeContextProperty } from '../theme/theme.context';

export const useThemeData = (): ThemeContextProperty => {
  const context = useContext(ThemeContext);

  return context;
};
